module.exports = __webpack_public_path__ + "img/home_main_bg.5380b3ca.png";